var React = require('react');

function Trash16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=16x16","stroke":"#676767","strokeWidth":"2"},[React.createElement("path",{"id":"Vector 235","d":"M1 4h5m9 0h-5M6 4V1h4v3M6 4h4","key":0}),React.createElement("path",{"id":"Vector 236","d":"M13 4H3v10.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V4z","key":1}),React.createElement("path",{"id":"Vector","d":"M10 7v5","key":2}),React.createElement("path",{"id":"Vector_2","d":"M6 7v5","key":3})]));
}

Trash16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Trash16x16;

Trash16x16.default = Trash16x16;
